import { ref } from "vue";

// Store facebook access token to use it for logout (for example)
const ssoAccessToken = ref<string>();

export function useSsoAccessToken() {
  return ssoAccessToken;
}
